import PhoneDetails from 'components/Auth/ForgotPassword/PhoneDetails'
import LoginDetails from 'components/Auth/Register/LoginDetails'
import PasswordSetup from 'components/Auth/Register/PasswordSetup'
import SMSVerification from 'components/Auth/Register/SMSVerification'
import UserDetails from 'components/Auth/Register/UserDetails'

export const validationPatterns = {
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    NUMBER: /\d+/,
}

export const registerStepsComponents = {
    loginDetails: LoginDetails,
    phoneVerification: SMSVerification,
    choosePassword: PasswordSetup,
    personalDetails: UserDetails,
}

export const forgotPasswordStepsComponents = {
    phoneDetails: PhoneDetails,
    phoneVerification: SMSVerification,
    choosePassword: PasswordSetup,
}
